import { render } from "./LoadingSpinner.vue?vue&type=template&id=0065bd20&scoped=true&bindings={\"display\":\"props\"}"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0065bd20"

export default script